// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__QNBLR","dragIcon":"Choice_dragIcon__1F5KI","left":"Choice_left__3qvW8","input":"Choice_input__1cn5Q"};